// src/pages/dashboard/PageDashboard.jsx
import { SubDashboard } from "../../components/SubDashboard";
import { BASE_URL } from "../../apiService";
import { MyTasksWidget } from "../../components/MyTasksWidget";
import { navIcon } from "../../navConfig";

export const ROLE_PRIORITY = ["ADMIN", "MANAGER", "ACCOUNTS", "SALES", "QC", "RND", "PRODUCTION", "STORES"];

export const DEPT_CONFIG = {
  ADMIN: {
    subtitle: "Management Overview",
    cards: [
      { id:"costing",     icon:navIcon("costing",24),     label:"Costing",              desc:"RM, SFG, FG, Hotmelt & pricing",            color:"#eff6ff", accent:"#1d4ed8" },
      { id:"logistics",   icon:navIcon("logistics",24),   label:"Logistics & Planning", desc:"Orders, planning & RM reorder",             color:"#fff7ed", accent:"#c2410c" },
      { id:"accounts",    icon:navIcon("accounts",24),    label:"Accounts & Finances",  desc:"Monthly reports, weekly reports & day book", color:"#f0fdf4", accent:"#15803d" },
      { id:"qc",          icon:navIcon("qc",24),          label:"Quality Control",       desc:"Specs, analysis, COA & non-conformance",    color:"#f0fdf4", accent:"#15803d" },
      { id:"rnd",         icon:navIcon("rnd",24),         label:"Research and Development", desc:"Formulations, pipeline & new products",  color:"#ede9fb", accent:"#6b21a8" },
      { id:"sales",       icon:navIcon("sales",24),       label:"Sales",                desc:"Order book & customer management",           color:"#fdf4ff", accent:"#7e22ce" },
      { id:"production",  icon:navIcon("production",24),  label:"Production",           desc:"Equipment & production backlog",             color:"#f0f9ff", accent:"#0369a1" },
      { id:"maintenance", icon:navIcon("maintenance",24), label:"Maintenance",          desc:"Spare parts & planned maintenance",          color:"#fafafa", accent:"#374151" },
      { id:"hr",          icon:navIcon("hr",24),          label:"Human Resources",     desc:"Payroll, employee records & self-service",   color:"#fdf2f8", accent:"#9d174d" },
      { id:"admin-hub",   icon:navIcon("admin-hub",24),   label:"Admin",                desc:"Audit log, users & roles",                   color:"#fff1f2", accent:"#be123c" },
    ],
  },
  MANAGER: {
    subtitle: "Management Overview",
    cards: [
      { id:"costing",     icon:navIcon("costing",24),     label:"Costing",              desc:"RM, SFG, FG, Hotmelt & pricing",            color:"#eff6ff", accent:"#1d4ed8" },
      { id:"logistics",   icon:navIcon("logistics",24),   label:"Logistics & Planning", desc:"Orders, planning & RM reorder",             color:"#fff7ed", accent:"#c2410c" },
      { id:"accounts",    icon:navIcon("accounts",24),    label:"Accounts & Finances",  desc:"Monthly reports, weekly reports & day book", color:"#f0fdf4", accent:"#15803d" },
      { id:"qc",          icon:navIcon("qc",24),          label:"Quality Control",       desc:"Specs, analysis, COA & non-conformance",    color:"#f0fdf4", accent:"#15803d" },
      { id:"rnd",         icon:navIcon("rnd",24),         label:"Research and Development", desc:"Formulations, pipeline & new products",  color:"#ede9fb", accent:"#6b21a8" },
      { id:"sales",       icon:navIcon("sales",24),       label:"Sales",                desc:"Order book & customer management",           color:"#fdf4ff", accent:"#7e22ce" },
      { id:"production",  icon:navIcon("production",24),  label:"Production",           desc:"Equipment & production backlog",             color:"#f0f9ff", accent:"#0369a1" },
      { id:"maintenance", icon:navIcon("maintenance",24), label:"Maintenance",          desc:"Spare parts & planned maintenance",          color:"#fafafa", accent:"#374151" },
      { id:"hr",          icon:navIcon("hr",24),          label:"Human Resources",     desc:"Payroll, employee records & self-service",   color:"#fdf2f8", accent:"#9d174d" },
      { id:"admin-hub",   icon:navIcon("admin-hub",24),   label:"Admin",                desc:"Audit log & settings",                       color:"#fafafa", accent:"#374151" },
    ],
  },
  ACCOUNTS: {
    subtitle: "Accounts Dashboard",
    cards: [
      { id:"accounts",  icon:navIcon("accounts",24),  label:"Accounts & Finances",  desc:"Monthly reports, weekly reports & day book", color:"#eff6ff", accent:"#1d4ed8" },
      { id:"logistics", icon:navIcon("logistics",24), label:"Logistics & Planning", desc:"Orders, planning & RM reorder",              color:"#fff7ed", accent:"#c2410c" },
    ],
  },
  SALES: {
    subtitle: "Sales Dashboard",
    cards: [
      { id:"sales", icon:navIcon("sales",24), label:"Sales", desc:"Order book & customer management", color:"#fdf4ff", accent:"#7e22ce" },
    ],
  },
  QC: {
    subtitle: "Quality Control",
    cards: [
      { id:"qc", icon:navIcon("qc",24), label:"Quality Control", desc:"Specs, analysis, COA & non-conformance", color:"#f0fdf4", accent:"#15803d" },
    ],
  },
  RND: {
    subtitle: "Research and Development",
    cards: [
      { id:"rnd", icon:navIcon("rnd",24), label:"Research and Development", desc:"Formulations, pipeline & new products", color:"#ede9fb", accent:"#6b21a8" },
    ],
  },
  PRODUCTION: {
    subtitle: "Production Dashboard",
    cards: [
      { id:"production",  icon:navIcon("production",24),  label:"Production",  desc:"Equipment & production backlog",    color:"#f0f9ff", accent:"#0369a1" },
      { id:"maintenance", icon:navIcon("maintenance",24), label:"Maintenance", desc:"Spare parts & planned maintenance", color:"#fafafa", accent:"#374151" },
    ],
  },
  STORES: {
    subtitle: "Stores Dashboard",
    cards: [
      { id:"logistics", icon:navIcon("logistics",24), label:"Logistics & Planning", desc:"Orders, planning & RM reorder", color:"#fff7ed", accent:"#c2410c" },
    ],
  },
};

export function PageDashboard({ userName, myRoles, rms, sfgs, fgs, setPage }) {
  const firstName   = userName ? userName.split(" ")[0] : "";
  const primaryRole = ROLE_PRIORITY.find(r => myRoles.includes(r)) ?? "STORES";
  const config      = DEPT_CONFIG[primaryRole] ?? DEPT_CONFIG["STORES"];
  return (
    <>
      <MyTasksWidget setPage={setPage} />
      <SubDashboard
        title={`Welcome, ${firstName}`}
        subtitle={config.subtitle}
        cards={config.cards}
        setPage={setPage}
        countMap={{ rm: rms.length, sfg: sfgs.length, fg: fgs.length }}
        showBack={false}
      />
    </>
  );
}

export function PageCostingDashboard({ setPage, rms, sfgs, fgs }) {
  return (
    <SubDashboard
      title="Costing" subtitle="Raw materials, formulations & pricing"
      setPage={setPage}
      countMap={{ rm: rms.length, sfg: sfgs.length, fg: fgs.length }}
      cards={[
        { id:"rm",       icon:navIcon("rm",24),       label:"Raw Materials",       desc:"Prices & master list",     color:"#ede9fb", accent:"#6b21a8" },
        { id:"sfg",      icon:navIcon("sfg",24),      label:"Semi-Finished Goods", desc:"Formulations & costs",     color:"#eff6ff", accent:"#1d4ed8" },
        { id:"fg",       icon:navIcon("fg",24),       label:"Finished Goods",      desc:"Recipes & selling prices", color:"#f0fdf4", accent:"#15803d" },
        { id:"hotmelt",  icon:navIcon("hotmelt",24),  label:"Hot Melt",            desc:"Hot melt costing cycles",  color:"#fdf4ff", accent:"#7e22ce" },
        { id:"history",      icon:navIcon("history",24),      label:"Price History",       desc:"RM price change log",             color:"#f0f9ff", accent:"#0369a1" },
        { id:"wb-snapshots",        icon:navIcon("wb-snapshots",24),        label:"WB Price Snapshots",  desc:"Monthly waterbase cost snapshots",       color:"#faf5ff", accent:"#7c3aed" },
        { id:"large-order-costing", icon:navIcon("large-order-costing",24), label:"Large Order Costing", desc:"Bulk order pricing with margins",        color:"#f0f9ff", accent:"#0369a1" },
        { id:"settings",            icon:navIcon("settings",24),            label:"Settings",            desc:"Global costing settings",               color:"#f8fafc", accent:"#475569" },
      ]}
    />
  );
}

export function PageLogisticsDashboard({ setPage }) {
  return (
    <SubDashboard
      title="Logistics & Planning" subtitle="Planning tools & calculators"
      setPage={setPage}
      cards={[
        { id:"rmcalc",            icon:navIcon("rmcalc",24),            label:"RM Calculator",       desc:"Plan raw material quantities",      color:"#fff7ed", accent:"#c2410c" },
        { id:"order-book",        icon:navIcon("order-book",24),        label:"Order Book",           desc:"Live open sales orders from Tally", color:"#eff6ff", accent:"#1d4ed8" },
        { id:"prod-planning",     icon:navIcon("prod-planning",24),     label:"Production Planning",  desc:"Coming soon",                       color:"#f0fdf4", accent:"#15803d" },
        { id:"rm-reorder",        icon:navIcon("rm-reorder",24),        label:"Raw Material Reorder", desc:"Coming soon",                       color:"#fdf4ff", accent:"#7e22ce" },
        { id:"delivery-planning", icon:navIcon("delivery-planning",24), label:"Delivery Planning",    desc:"Coming soon",                       color:"#f0f9ff", accent:"#0369a1" },
      ]}
    />
  );
}

export function PageAccountsDashboard({ setPage }) {
  return (
    <SubDashboard
      title="Accounts & Finances" subtitle="Reports, records & financial overview"
      setPage={setPage}
      cards={[
        { id:"accounts-monthly-reports", icon:navIcon("accounts-monthly-reports",24), label:"Monthly Reports", desc:"Forecast vs actuals per customer", color:"#eff6ff", accent:"#1d4ed8" },
        { id:"accounts-weekly-report",   icon:navIcon("accounts-weekly-report",24),   label:"Weekly Report",   desc:"Coming soon",                     color:"#f0fdf4", accent:"#15803d" },
        { id:"accounts-daybook",         icon:navIcon("accounts-daybook",24),         label:"Day Book",        desc:"Coming soon",                     color:"#fff7ed", accent:"#c2410c" },
      ]}
    />
  );
}

export function PageProductionDashboard({ setPage }) {
  return (
    <SubDashboard
      title="Production" subtitle="Equipment & production management"
      setPage={setPage}
      cards={[
        { id:"prod-equipment", icon:navIcon("prod-equipment",24), label:"Equipment",           desc:"Coming soon",                                 color:"#f0f9ff", accent:"#0369a1" },
        { id:"prod-backlog",   icon:navIcon("prod-backlog",24),   label:"Production Backlog",  desc:"Coming soon",                                 color:"#eff6ff", accent:"#1d4ed8" },
        { id:"mixer-config",   icon:navIcon("mixer-config",24),   label:"Mixer Configuration", desc:"Capacity, batch timings & grade assignments", color:"#f0fdf4", accent:"#15803d" },
      ]}
    />
  );
}

export function PageMaintenanceDashboard({ setPage }) {
  return (
    <SubDashboard
      title="Maintenance" subtitle="Spare parts & planned maintenance"
      setPage={setPage}
      cards={[
        { id:"maint-spares",  icon:navIcon("maint-spares",24),  label:"Spare Parts List",         desc:"Coming soon", color:"#fafafa", accent:"#374151" },
        { id:"maint-planned", icon:navIcon("maint-planned",24), label:"Planned Maintenance Logs", desc:"Coming soon", color:"#fff7ed", accent:"#c2410c" },
      ]}
    />
  );
}

export function PageHRDashboard({ setPage }) {
  return (
    <SubDashboard
      title="Human Resources" subtitle="People management, payroll & compliance"
      setPage={setPage}
      cards={[
        { id:"hr-employees",    icon:navIcon("hr-employees",24),    label:"Employee Records",
          desc:"Detailed profiles, salary breakdowns, leave management & gratuity calculations",
          color:"#fdf2f8", accent:"#9d174d" },
        { id:"hr-payroll",      icon:navIcon("hr-payroll",24),      label:"Payroll & WPS",
          desc:"One-click salary calculations with allowances, deductions, overtime & WPS SIF file generation",
          color:"#fff7ed", accent:"#c2410c" },
        { id:"hr-documents",    icon:navIcon("hr-documents",24),    label:"Document Expiry Reminders",
          desc:"Timely alerts for employee and company document renewals to ensure compliance",
          color:"#fefce8", accent:"#a16207" },
        { id:"hr-self-service", icon:navIcon("hr-self-service",24), label:"Employee Self-Service",
          desc:"Staff requests for leave, cash advances & salary certificates with manager approvals",
          color:"#f0fdf4", accent:"#15803d" },
        { id:"hr-reports",      icon:navIcon("hr-reports",24),      label:"HR Reports",
          desc:"Payroll reports, salary slips & exports in PDF or Excel for analysis and record-keeping",
          color:"#eff6ff", accent:"#1d4ed8" },
      ]}
    />
  );
}

export function PageAdminDashboard({ setPage }) {
  return (
    <SubDashboard
      title="Admin" subtitle="Users, roles & audit trail"
      setPage={setPage}
      cards={[
        { id:"auditlog",      icon:navIcon("auditlog",24),      label:"Audit Log",                  desc:"All system changes",                                  color:"#fafafa", accent:"#374151" },
        { id:"users",         icon:navIcon("users",24),         label:"Users",                      desc:"Manage access & roles",                               color:"#fff1f2", accent:"#be123c" },
        { id:"system-health", icon:navIcon("system-health",24), label:"System Health",              desc:"App & TallyPrime connectivity",                       color:"#f0fdf4", accent:"#15803d" },
        { id:"crm-groups",    icon:navIcon("crm-groups",24),    label:"Sales Module Control Panel", desc:"Assign groups, refresh cache & monthly reports",      color:"#f0fdf4", accent:"#15803d" },
        { id:"infra-keys",    icon:navIcon("infra-keys",24),    label:"Infrastructure Keys",        desc:"API keys, auth tokens & expiry dates",                color:"#eff6ff", accent:"#1d4ed8" },
        { id:"swagger",       icon:navIcon("swagger",24),       label:"API Docs",                   desc:"Swagger UI — explore & test backend APIs",            color:"#fefce8", accent:"#a16207",
          href: `${BASE_URL}/swagger-ui/index.html` },
      ]}
    />
  );
}

export function PageQCDashboard({ setPage }) {
  return (
    <SubDashboard
      title="Quality Control" subtitle="Specifications, analysis, COA & non-conformance"
      setPage={setPage}
      cards={[
        { id:"qc-fg-specs",         icon:navIcon("qc-fg-specs",24),         label:"Water Based Specifications",       desc:"Water based adhesive specs & tolerances",     color:"#f0fdf4", accent:"#15803d" },
        { id:"qc-rm-specs",         icon:navIcon("qc-rm-specs",24),         label:"RM Specifications",                desc:"Raw material acceptance specs",               color:"#eff6ff", accent:"#1d4ed8" },
        { id:"qc-hm-specs",         icon:navIcon("qc-hm-specs",24),         label:"Hotmelt Specifications",           desc:"Hot melt adhesive spec sheets",               color:"#fff7ed", accent:"#c2410c" },
        { id:"qc-totalenergies",    icon:navIcon("qc-totalenergies",24),    label:"TotalEnergies",                    desc:"Coolant & brake fluid specs and analysis",    color:"#f0f9ff", accent:"#0369a1" },
        { id:"qc-analysis",         icon:navIcon("qc-analysis",24),         label:"Water Based Daily Analysis",       desc:"Test results & pass/fail verdicts",           color:"#fdf4ff", accent:"#7e22ce" },
        { id:"qc-hm-analysis",      icon:navIcon("qc-hm-analysis",24),      label:"Hotmelt Analysis",                 desc:"Hot melt daily test results",                 color:"#fff7ed", accent:"#c2410c" },
        { id:"qc-rm-analysis",      icon:navIcon("qc-rm-analysis",24),      label:"RM Analysis",                      desc:"Incoming raw material analysis",              color:"#eff6ff", accent:"#1d4ed8" },
        { id:"rd-rm-evaluation",    icon:navIcon("rd-rm-evaluation",24),    label:"New RM Evaluation",                desc:"New & alternate raw material evaluations",    color:"#fdf4ff", accent:"#7e22ce" },
        { id:"qc-customer-samples", icon:navIcon("qc-customer-samples",24), label:"Customer Samples",                 desc:"Test samples & find closest formulation",     color:"#ecfdf5", accent:"#059669" },
        { id:"qc-coa",              icon:navIcon("qc-coa",24),              label:"Generate COA",                     desc:"Certificate of Analysis PDFs",                color:"#fdf4ff", accent:"#7e22ce" },
        { id:"qc-daily-water",      icon:navIcon("qc-daily-water",24),      label:"Daily Water Analysis",             desc:"Feed, RO & reject water — TDS · pH · Temp",  color:"#eff6ff", accent:"#1d4ed8" },
        { id:"qc-rm-nc",            icon:navIcon("qc-rm-nc",24),            label:"Non Conformance (Raw Material)",   desc:"Log and track RM non-conformance reports",   color:"#fff7ed", accent:"#c2410c" },
        { id:"qc-fg-nc",            icon:navIcon("qc-fg-nc",24),            label:"Non Conformance (Finished Goods)", desc:"Log and track FG non-conformance reports",   color:"#fff7ed", accent:"#c2410c" },
        { id:"customer-complaints", icon:navIcon("customer-complaints",24), label:"Customer Complaints",              desc:"Complaints raised by customers",              color:"#fdf4ff", accent:"#7e22ce" },
        { id:"rd-equipment",        icon:navIcon("rd-equipment",24),        label:"Equipment List",                   desc:"Lab equipment register & calibration status", color:"#f0f9ff", accent:"#0369a1" },
        { id:"qc-calibration",      icon:navIcon("qc-calibration",24),      label:"Calibration Records",              desc:"Equipment calibration logs & due dates",      color:"#fefce8", accent:"#a16207" },
        { id:"qc-tds",              icon:navIcon("qc-tds",24),              label:"Technical Data Sheets",            desc:"Version-controlled TDS for all products",     color:"#eff6ff", accent:"#1d4ed8" },
        { id:"qc-msds",             icon:navIcon("qc-msds",24),             label:"Material Safety Data Sheets",      desc:"MSDS for water based and hotmelt grades",     color:"#fff7ed", accent:"#c2410c" },
      ]}
    />
  );
}

export function PageRnDDashboard({ setPage }) {
  return (
    <SubDashboard
      title="Research and Development" subtitle="Formulations, pipeline & new product development"
      setPage={setPage}
      cards={[
        { id:"qc-rd-pipeline",      icon:navIcon("qc-rd-pipeline",24),      label:"R&D Pipeline",               desc:"Active R&D projects & trials",             color:"#f0fdf4", accent:"#15803d" },
        { id:"rd-new-product",      icon:navIcon("rd-new-product",24),      label:"New Product Development",    desc:"NPD tracking & stage gate",                color:"#fff7ed", accent:"#c2410c" },
        { id:"rd-rm-evaluation",    icon:navIcon("rd-rm-evaluation",24),    label:"New RM Evaluation",          desc:"New & alternate raw material evaluations", color:"#fdf4ff", accent:"#7e22ce" },
        { id:"qc-customer-samples", icon:navIcon("qc-customer-samples",24), label:"Customer Samples",           desc:"Test samples & find closest formulation",  color:"#ecfdf5", accent:"#059669" },
        { id:"qc-analysis",         icon:navIcon("qc-analysis",24),         label:"Water Based Daily Analysis", desc:"Test results & pass/fail verdicts",         color:"#fdf4ff", accent:"#7e22ce" },
        { id:"rd-equipment",        icon:navIcon("rd-equipment",24),        label:"Equipment List",             desc:"R&D lab equipment register",               color:"#f0f9ff", accent:"#0369a1" },
        { id:"qc-calibration",      icon:navIcon("qc-calibration",24),      label:"Calibration Records",        desc:"Equipment calibration logs & due dates",   color:"#fefce8", accent:"#a16207" },
      ]}
    />
  );
}

export function PageTotalEnergiesDashboard({ setPage }) {
  return (
    <SubDashboard
      title="TotalEnergies" subtitle="Coolant & brake fluid specifications and analysis"
      showBack={false}
      setPage={setPage}
      cards={[
        { id:"qc-coolant-specs", icon:navIcon("qc-coolant-specs",24), label:"Coolant Specifications",     desc:"Coolant acceptance specifications",        color:"#f0f9ff", accent:"#0369a1" },
        { id:"qc-brake-specs",   icon:navIcon("qc-brake-specs",24),   label:"Brake Fluid Specifications", desc:"Brake fluid acceptance specifications",    color:"#eff6ff", accent:"#1d4ed8" },
        { id:"qc-coolant",       icon:navIcon("qc-coolant",24),       label:"Coolant Analysis",           desc:"Coolant testing & pass/fail verdicts",     color:"#f0fdf4", accent:"#15803d" },
        { id:"qc-brake",         icon:navIcon("qc-brake",24),         label:"Brake Fluid Analysis",       desc:"Brake fluid testing & pass/fail verdicts", color:"#fafafa", accent:"#374151" },
      ]}
    />
  );
}
